import React from "react";
import { PolarArea } from "react-chartjs-2";

const data = {
  labels: ["Active Buyers", "Active Stores", "Active Admins"],
  datasets: [
    {
      backgroundColor: ["#2ecc71", "#ed3b47", "#95a5a6"],
      data: [12, 19, 3],
    },
  ],
};

const options = {
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: false,
        },
      },
    ],
  },
};

const WeeklySales = () => (
  <>
    <div className="header">
      <h2 className="title" style={{ textAlign: "center" }}>
        Users Active Status
      </h2>
    </div>
    <PolarArea width={100} height={490} data={data} options={options} />
  </>
);

export default WeeklySales;
